import { UseFormWatch } from 'react-hook-form';
import { EditableQuestion, QuestionType } from '../../../../../types';

/**
 * Hiding presupposes a selection to hide, and only a single radio selection has one a
 * continue button can stand in for. Every other type either collects what the patient
 * types or asks for a choice that has to be made.
 */
export const useShouldShowAnswerSelection = (watch: UseFormWatch<EditableQuestion>) =>
  watch('type') === QuestionType.SINGLE_RADIO_SELECTION;
